export default __webpack_public_path__ + "static/media/StAlbertLogo.84a28ba7.png";